import Button from '@allesauto/core/button';
import Headline from '@allesauto/core/headline';
import NextImage from '@allesauto/core/nextImage';
import { pushAnalyticsEvent } from '@allesauto/utils/analytics';
import { FieldTypeAsset } from '@allesauto/utils/consts';
import { sbEditable } from '@storyblok/storyblok-editable';
import clsx from 'clsx';
import React from 'react';

interface WhitepaperDownloadProps {
  component: string;
  _uid: string;
  headline: string;
  description?: string;
  image: FieldTypeAsset;
  pdfFile: FieldTypeAsset;
  buttonLabel: string;
  background: 'GREEN' | 'WHITE' | 'GREY' | 'BLACK' | 'PURPLE';
  withPadding: boolean;
  headlineTag: 2 | 3;
  headlineFontSize: 'text-title' | 'headline2' | 'headline3' | 'headline4';
  imagePosition: 'right' | 'left';
}

const cssClasses = {
  container: 'grid grid-cols-1 lg:grid-cols-2',
  description: 'mt-[24px]',
  button: 'sm:w-full md:w-[400px] mt-40px',
  content: 'flex flex-col justify-between py-[40px] px-[60px]',
  image: 'relative min-h-[400px]',
  padding: 'sm:p-10px md:p-40px',
};

const theme = {
  PURPLE: {
    background: 'bg-purple80 monochrome:bg-grey90',
    text: 'text-white monochrome:text-white',
  },
  GREEN: {
    background: 'bg-green60 monochrome:bg-grey40',
    text: 'text-purple80 monochrome:text-grey90',
  },
  WHITE: {
    background: 'bg-white',
    text: 'text-purple80 monochrome:text-grey90',
  },
  GREY: {
    background: 'bg-grey10',
    text: 'text-purple80 monochrome:text-grey90',
  },
  BLACK: {
    background: 'bg-grey90',
    text: 'text-green60 monochrome:text-white',
  },
};

const WhitepaperDownload = (props: WhitepaperDownloadProps) => {
  const {
    headline,
    description,
    image,
    pdfFile,
    buttonLabel,
    background,
    withPadding,
    headlineTag = 3,
    headlineFontSize = 'headline3',
    imagePosition = 'left',
  } = props;

  const downloadPdfFile = () => {
    window.open(pdfFile.filename, '_blank');
    pushAnalyticsEvent({
      event: 'click_pdf_download_cta_button',
    });
  };

  return (
    <section
      {...sbEditable(props)}
      className={clsx(
        cssClasses.container,

        withPadding && cssClasses.padding
      )}
    >
      <div
        className={clsx(
          cssClasses.image,
          imagePosition === 'right' && 'order-1'
        )}
      >
        <NextImage
          objectFit="cover"
          layout="fill"
          src={image.filename}
          alt={image.alt}
        />
      </div>
      <div className={clsx(cssClasses.content, theme[background].background)}>
        <div>
          <Headline
            headlineTag={headlineTag}
            headlineText={headline}
            headlineColor={theme[background].text}
            headlineClassName={`text-${headlineFontSize}`}
          />
          {description && (
            <p className={clsx(cssClasses.description, theme[background].text)}>
              {description}
            </p>
          )}
        </div>

        <Button
          darkBg
          onClick={downloadPdfFile}
          text={buttonLabel}
          customClassName={cssClasses.button}
        />
      </div>
    </section>
  );
};

export default WhitepaperDownload;
